import 'lib/jwplayer';
import 'lib/jwplayer.core.controls.html5';
import dependencyLoader from '../../utility/dependency-loader';

dependencyLoader(0, context => {
  return context;
});
